import RestService from '@/contracts/RestService';
export default class MediaService extends RestService {
    uri = '/media';
}
